import React from 'react'
import { Observable } from 'rxjs'
import { AppConfig } from '../types/AppConfig'
import { PricesExtended, ServerType } from '@bdswiss/mt4-connector'
import { MT4DatafeedBase } from '../lib/charting_library/datafeed/mt4-datafeed-base'
import { RootState } from '../types'
import moment from 'moment-timezone'
import { APPLY_POST_COMMAND } from '../constants'
import { MiddlewareAPI } from 'redux'
import { Epic } from 'redux-observable'
import { ApplyPostCommand } from '../actions/commonActions'
import { checkTradingHours } from '../utils/common-utils'

export interface Props {
  appConfig: AppConfig
  serverType: ServerType
  symbol: string
  resolution: string
  timeframe: string
  type: number // per TradingView specs
  locale: string
  currency: string
  // positions: Trades;
  assets: PricesExtended
  visibleRange?: { from: number; to: number; interval: string }
  selectedPosition?: number
  positionsOpened?: boolean
  positionExpanded?: boolean
  //    onChangeSymbol: (symbol:string) => void;
  //    onSelectPosition: (order: number, expanded?: boolean) => void;
  onChartReady: () => void
  //    onInputStopLoss: (order: number, value: number) => void;
  //    onInputTakePorfit: (order: number, value: number) => void;
}

export interface State {
  prevType: number
  visibleRange: { from: number; to: number; timeScale: number }
}

const BondTradingChart = (props: Props) => {
  return <BondTradingChartContent {...props} />
}
let chartComponent: BondTradingChartContent
let propagatedExternally: boolean = false

export const applyPostCommandEpic: Epic<ApplyPostCommand, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(APPLY_POST_COMMAND).mergeMap(() => {
    propagatedExternally = true
    chartComponent.updateResolutionVisibleRange()
    // chartComponent.updateVisibleRange();
    return Observable.empty()
  })

class BondTradingChartContent extends React.Component<Props, State> {
  // private chart: HTMLDivElement | null;

  private chart: any
  // private rangeSynced: boolean = true;

  constructor(props: Props) {
    super(props)
    chartComponent = this
    // this.chart = React.createRef();
    this.state = {
      prevType: 1,
      visibleRange: { from: 0, to: 0, timeScale: 0 },
    }
  }

  public render() {
    return (
      <div id="tv_chart_container" className="chart-wrapper" /> // ref={(div) => this.chart = div }/>
    )
  }

  public componentDidMount() {
    // moment.tz.guess()
    // const {} = this.props.appConfig;
    const { resolution, timeframe, locale } = this.props
    const symbol = checkTradingHours(this.props.symbol, this.props.assets)
    const widget = ((Window as any).tvWidget = new (TradingView as any).widget({
      // debug: true, // uncomment this line to see Library errors and warnings in the console
      timezone: moment.tz.guess(),
      fullscreen: true,
      autosize: true,
      symbol,
      interval: resolution,
      timeframe,
      container_id: 'tv_chart_container',
      // BEWARE: no trailing slash is expected in feed URL
      datafeed: new MT4DatafeedBase(),
      library_path: '/assets/charting_library/',
      locale,
      // Regression Trend-related functionality is not implemented yet, so it's hidden for a while
      drawings_access: { type: 'black', tools: [{ name: 'Regression Trend' }] },
      disabled_features: [
        'use_localstorage_for_settings',
        'header_saveload',
        'header_compare',
        'header_symbol_search',
        'left_toolbar',
      ], //  'header_screenshot',
      // enabled_features: ['study_templates'],
      charts_storage_url: 'http://saveload.tradingview.com',
      charts_storage_api_version: '1.1',
      client_id: 'tradingview.com',
      user_id: 'public_user_id',
      favorites: {
        intervals: ['240'],
        chartTypes: ['Candles', 'Line'],
      },
    }))
    widget.onChartReady(() => {
      this.props.onChartReady()
      this.chart = widget.activeChart()
      this.chart.onIntervalChanged().subscribe(null, (interval: any, obj: any) => {
        // debugger; // eslint-disable-line
        // console.log(JSON.stringify(obj));
        // this.updateVisibleRange();
        if (/^\d+S$/.test(this.chart.resolution())) {
          this.setState((state) => Object.assign(state, { type: this.chart.chartType() }))
          this.chart.setChartType(2)
        } else {
          this.chart.setChartType(this.state.prevType)
        }
      })

      this.chart.onDataLoaded().subscribe(null, (data: any) => {
        // const {from, to} = this.chart.getVisibleRange();
        // const now = new Date().getTime() / 1000;
        // console.log('data loaded'+ data + `${from}, ${to}, ${from-to}, ${now}:${(now-from)/60}m ${(now-from)/60/60}h ${(now-from)/60/60/24}d`);
        if (propagatedExternally) {
          propagatedExternally = false
          // this.updateVisibleRange()
        }
      })
    })
  }

  public shouldComponentUpdate() {
    return true
  }

  public updateResolutionVisibleRange() {
    if (this.chart && this.props.visibleRange) {
      const { interval } = this.props.visibleRange
      // this.rangeSynced = false;
      if (this.chart.resolution() !== interval) {
        this.chart.setResolution(interval)
      } else {
        // console.log(2);
        // this.updateVisibleRange()
      }
    }
  }

  // public updateVisibleRange() {
  //   const currentRange = this.chart.getVisibleRange()
  //   const { from, to } = this.props.visibleRange!
  //   if (from !== currentRange.from || to !== currentRange.to) {
  //     // console.log('changing range');
  //     this.state.visibleRange.from = from
  //     this.state.visibleRange.to = to

  //     this.chart.setVisibleRange({ from, to })
  //     // console.log(`[${moment(from*1000).format(`hh:mm`)}, ${moment(to*1000).format(`hh:mm`)}] ${(to- from) /60}`);
  //   }
  // }

  public componentDidUpdate(prevProps: Props, prevState: State) {
    // only update chart if the data has changed
    if (prevProps.symbol !== this.props.symbol) {
      this.chart.setSymbol(this.props.symbol, () => {
        // console.log('symbolChanged');
        // this.updateResolutionVisibleRange();
      })
    } else {
      // this.updateResolutionVisibleRange();
    }
  }
}

export default BondTradingChart
